import axios from 'axios'
import { Message } from 'element-ui'
// import store from '@/store'
import { removeToken,getToken } from '@/utils/auth'
const _Message = Message;
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
      if(getToken()){
        config.headers['Authorization'] = 'Bearer ' + getToken()
      }      
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    if (response.data.code === 0 || response.data.code === 200) {
      return Promise.resolve(res)
    } else if (res.code !== 20000) {
      Message.error(res.message || 'Error');
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    let message = ''
    if(error && error.response) {
      switch(error.response.status) {
          case 401:
            removeToken();
            message = error.response.data.message ? error.response.data.message : '无效的访问令牌'
            break;              
          case 403:
              message = error.response.data.path + ',' + error.response.data.message
              break
          case 502:
              message = '连接服务器失败'
              break
          case 429:
              message = '访问太过频繁，请稍后再试!'
              break
          default:
              message = error.response.data.message ? error.response.data.message : '服务器错误'
              break
      }
      // Message.error({ content: message })
      _Message.error(message)
      // 请求错误处理
      return Promise.reject(error)
  } else {
      message = '连接服务器失败'
      _Message.error(message)
      return Promise.reject(error)
  }
  }
)

export default service
